var _defs, _path, _circle, _path2, _path3, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureKeyVault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 9,
    cy: 9,
    r: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5c9fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#559ced"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4a97e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#3990e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2387de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#087bd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 38.95,
    cy: 182.07,
    r: 9.88,
    gradientTransform: "matrix(.94 0 0 .94 -28.71 -163.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ffd70f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ffcb12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#feac19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fea11b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .5A8.5 8.5 0 1017.5 9 8.51 8.51 0 009 .5zm0 15.84A7.34 7.34 0 1116.34 9 7.34 7.34 0 019 16.34z",
    fill: "url(#a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.34,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.44 7.33a1.84 1.84 0 000-2.59l-3.15-3.16a1.83 1.83 0 00-2.58 0L4.56 4.74a1.84 1.84 0 000 2.59L7.18 10a.51.51 0 01.15.36v4.88a.63.63 0 00.18.44l1.2 1.2a.41.41 0 00.58 0l1.16-1.16.68-.68a.25.25 0 000-.34l-.49-.49a.27.27 0 010-.37l.49-.49a.25.25 0 000-.34l-.49-.49a.27.27 0 010-.37l.49-.49a.25.25 0 000-.34l-.68-.69v-.25zM9 2.35a1 1 0 010 2.07 1 1 0 110-2.07z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18 15.3a.23.23 0 00.38-.17v-4a.24.24 0 00-.11-.2.22.22 0 00-.34.2v4a.28.28 0 00.07.17z",
    fill: "#ff9300",
    opacity: 0.75
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.48,
    y: 5.79,
    width: 5.17,
    height: 0.61,
    rx: 0.28,
    fill: "#ff9300",
    opacity: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.48,
    y: 6.78,
    width: 5.17,
    height: 0.61,
    rx: 0.28,
    fill: "#ff9300",
    opacity: 0.75
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureKeyVault);
export default __webpack_public_path__ + "static/media/azure-keyVault.a5ac63f409a07e135da7472478f89de1.svg";
export { ForwardRef as ReactComponent };